module.exports = __webpack_public_path__ + "img/c9.b012a411.png";